import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import AssignmentList from "../../../Components/AssignmentList";
import Universities from "../../../Components/Universities";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const VideoSolutions = () => {
  const subCategoryId = "698d957fc0f37ade0740edd5";
  const categoryId = "65524e633c005ef3b51907c9";

  const [isModelOpen, setIsModelOpen] = useState(false);

  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };
  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Assignment Help" },
    { label: "Video Solutions" },
  ];

  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection />
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Benefits of Video Solution Services"
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <AssignmentList
        subCategoryId={subCategoryId}
        title="Recently Completed Video Solutions Samples"
      />
      <HelpSteps
        subCategoryId={subCategoryId}
        description="Get your Video solutions support in 4 easy steps"
      />
      <Milestonerewards categoryId={categoryId} />
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts
        title="Meet our Video Solution Experts"
        description="Our professionals deliver high-quality video solutions with an improved visual "
      />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps: 1,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default VideoSolutions;
